import {
  About,
  ArtistsListing,
  ConcertInner,
  ConcertListing,
  Contact,
  Donate,
  FAQ,
  Home,
  NewsInner,
  NewsListing,
  Press,
  PressForm,
  PressInner,
  Sponsors,
  Test,
  PageNotFound,
  Search,
  LivePage,
  PrivacyPolicy,
} from './pages';

export default [
  {
    exact: true,
    path: '/',
    component: Home,
  },
  {
    exact: true,
    path: '/calendar',
    component: ConcertListing,
  },
  {
    exact: true,
    path: '/about',
    component: About,
  },

  {
    exact: true,
    path: '/calendar/:url',
    component: ConcertInner,
  },
  {
    exact: true,
    path: '/artists',
    component: ArtistsListing,
  },
  {
    exact: true,
    path: '/faq',
    component: FAQ,
  },
  {
    exact: true,
    path: '/contact',
    component: Contact,
  },

  {
    exact: true,
    path: '/press',
    component: Press,
  },
  {
    exact: true,
    path: '/press_form',
    component: PressForm,
  },
  {
    exact: false,
    path: '/press/:url/:media',
    component: PressInner,
  },
  {
    exact: true,
    path: '/calendar/:url',
    component: ConcertInner,
  },
  {
    exact: true,
    path: '/artists',
    component: ArtistsListing,
  },
  {
    exact: true,
    path: '/faq',
    component: FAQ,
  },
  {
    exact: true,
    path: '/contact',
    component: Contact,
  },
  {
    exact: true,
    path: '/news',
    component: NewsListing,
  },
  {
    exact: true,
    path: '/news/:url',
    component: NewsInner,
  },
  {
    exact: true,
    path: '/fundraising',
    component: Donate,
  },
  {
    exact: true,
    path: '/donate',
    component: Donate,
  },
  {
    exact: true,
    path: '/partners',
    component: Sponsors,
  },
  {
    exact: true,
    path: '/test',
    component: Test,
  },
  {
    exact: true,
    path: '/search',
    component: Search,
  },
  {
    exact: true,
    path: '/search/:url',
    component: Search,
  },

  {
    exact: true,
    path: '/live',
    component: LivePage,
  },

  {
    exact: true,
    path: '/privacy-policy',
    component: PrivacyPolicy,
  },

  {
    component: PageNotFound,
  },
];
